import { render } from "./MktHomePage.vue?vue&type=template&id=4fdaa7f4&scoped=true"
import script from "./MktHomePage.vue?vue&type=script&lang=js"
export * from "./MktHomePage.vue?vue&type=script&lang=js"

import "./MktHomePage.vue?vue&type=style&index=0&id=4fdaa7f4&scoped=true&lang=css"

import exportComponent from "/Users/tinypocket/workspace/joysun/repositories/joysun-ems/joysun-ems-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4fdaa7f4"]])

export default __exports__